import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  Checkbox,
  CrudForm,
  CrudRoute,
  CrudTabs,
  Snackbar,
  TextField,
  useEntityManager,
  useTabsNavigation
} from 'elentari'
import UsuariosRepository from './UsuariosRepository'
import { REALMS } from './Usuarios'
import { abilityFor, useAbility } from '.'
import { Email, Usuario } from '../../components'
import MetasAnalistaForm from './Metas/MetasAnalistaForm'
import MetasAnalista from './Metas/MetasAnalista'
import api from '../../services/Api'
import AlertDialog from '../../components/AlertDialog'
import * as yup from 'yup'
import yupValidation from '../../lib/yupValidation'
import CentroCustoAutocomplete from '../CentrosCusto/CentroCustoAutocomplete'
import { parseCpf, parseTelefone } from '../../utils/Parse'
import moment from 'moment'
import { opcoesPrioridadeOptions } from './utils'
import CustomSelect from '../../components/Select'

const usuarioSchema = yup.object().shape({
  usuario: yup.string().required('Obrigatório'),
  codigoLotacao: yup
    .string()
    .nullable()
    .required('Obrigatório'),
  email: yup
    .string()
    .email('Email Inválido')
    .required('Obrigatório'),
  opcaoPrioridade: yup
    .string()
    .nullable()
    .required('Obrigatório')
})

const validate = yupValidation(usuarioSchema)

const UsuarioForm = props => {
  const [ability, setAbility] = useAbility()
  const [open, setOpen] = useState(false)
  const [formData, setFormData] = useState(null)
  const [mensagem, setMensagem] = useState('')

  const logoutSubmit = async () => {
    const response = await UsuariosRepository.patch(formData.id, formData)
    const user = await api.getUserInfo()
    if (response.ok) {
      const formattedUser = {
        id: formData.id,
        token: response.config.headers['x-auth-token'],
        ok: response.ok,
        name: user?.data?.usuario,
        realm: formData.realm
      }
      localStorage.setItem('user', JSON.stringify(formattedUser))
      localStorage.setItem('empresa', String(response.data.usuario.empresaId))

      setAbility(abilityFor(formattedUser))
      props.history.replace('/')
    } else {
      setMensagem(response.data?.error?.message)
    }
    setOpen(false)
  }

  const handleSubmit = async data => {
    if (data.reativarUsuario) {
      data.deletedAt = null
      delete data.reativarUsuario
    }
    setFormData(data)
    const user = await api.getUserInfo()
    if (user.ok) {
      if (user.data.id === data.id && user.data.realm !== data.realm) {
        // Estou tentando alterar meu realm
        return setOpen(true)
      }
    } else {
      return setMensagem('Erro ao buscar dados do usuário')
    }
    return entityManager.onSubmit(data)
  }
  const entityManager = useEntityManager({
    repository: UsuariosRepository,
    handleError: data => data.message
  })
  const cannotUpdate =
    ability.cannot('update', 'usuarios') && !entityManager.isNew

  const isUserInativado = !!entityManager.item.deletedAt

  const formatCargo = value => {
    const realm = REALMS.find(realm => realm.value === value)
    return realm?.label
  }

  return (
    <>
      <CrudForm
        {...props}
        disableSubmit={cannotUpdate}
        {...entityManager}
        validate={validate}
        onSubmit={handleSubmit}
        withPaper
      >
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <Field
              fullWidth
              disabled
              name="nome"
              label="Nome"
              component={TextField}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Usuario disabled />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Email disabled />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Field
              fullWidth
              disabled
              format={parseCpf}
              name="cpf"
              label="CPF"
              InputLabelProps={{ shrink: true }}
              component={TextField}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Field
              fullWidth
              name="telefone"
              label="Telefone"
              InputLabelProps={{ shrink: true }}
              format={parseTelefone}
              component={TextField}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Field
              fullWidth
              name="codigoLotacao"
              label="Centro de custo"
              component={CentroCustoAutocomplete}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Field
              fullWidth
              disabled
              name="realm"
              label="Cargo"
              component={TextField}
              InputLabelProps={{ shrink: true }}
              format={formatCargo}
              hideEmpty
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Field
              fullWidth
              hideEmpty
              component={CustomSelect}
              options={opcoesPrioridadeOptions}
              label="Opções de Prioridade"
              name="opcaoPrioridade"
            />
          </Grid>
          {isUserInativado && (
            <>
              <Grid item sm={4} xs={12}>
                <Field
                  fullWidth
                  format={data =>
                    data && moment(data).format('DD/MM/YYYY HH:mm')
                  }
                  name="deletedAt"
                  label="Usuário Inativado Em"
                  disabled
                  InputLabelProps={{ shrink: true }}
                  component={TextField}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Field
                  component={Checkbox}
                  disabled={cannotUpdate}
                  label="Reativar Usuário"
                  name="reativarUsuario"
                  type="checkbox"
                />
              </Grid>
            </>
          )}
          <Grid item sm={isUserInativado ? 6 : 4} xs={12}>
            <Field
              component={Checkbox}
              disabled={cannotUpdate}
              label="Liberar Automaticamente na Consulta"
              name="liberarAutomaticamenteConsulta"
              type="checkbox"
            />
          </Grid>
        </Grid>
      </CrudForm>
      <AlertDialog
        open={open}
        handleClose={() => setOpen(false)}
        closeButtonText="Voltar"
        primaryButtonText="Confirmar"
        message="Tem certeza de que deseja confirmar a ação? Você será redirecionado à pagina inicial do novo cargo selecionado."
        primaryAction={() => logoutSubmit()}
      />
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </>
  )
}

function UsuarioTabs(props) {
  const entityManager = useEntityManager({ repository: UsuariosRepository })
  const isUsuarioAnalista = entityManager.item.realm === 'analista'

  const tabs = [{ value: '', label: 'Usuários' }]
  if (isUsuarioAnalista) tabs.push({ value: 'metas', label: 'Metas' })

  const tabsNavigation = useTabsNavigation({
    mainPath: 'usuarios',
    tabs
  })
  return (
    <CrudTabs {...tabsNavigation}>
      <div>
        <CrudRoute render={() => <UsuarioForm {...props} />} />
        <CrudRoute
          name="metas"
          render={props => (
            <MetasAnalista
              onClickNew={tabsNavigation.toNewChild}
              onClickEdit={tabsNavigation.toEditChild}
              {...props}
            />
          )}
        />
        <CrudRoute
          name="metas"
          isForm
          render={props => <MetasAnalistaForm {...props} />}
        />
      </div>
    </CrudTabs>
  )
}

export default UsuarioTabs
